import { render } from "./AccessDenied.vue?vue&type=template&id=21efbcf6&scoped=true"
import script from "./AccessDenied.vue?vue&type=script&lang=js"
export * from "./AccessDenied.vue?vue&type=script&lang=js"

import "./AccessDenied.vue?vue&type=style&index=0&id=21efbcf6&lang=scss&scoped=true"

import exportComponent from "/media/ctis/developer/WorkSpaceFront/eventos-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21efbcf6"]])

export default __exports__